var map = {
	"./holdingpen-editor/holdingpen-editor.module.ngfactory": [
		"TSi0",
		0,
		3
	],
	"./multi-editor/multi-editor.module.ngfactory": [
		"L4VK",
		0,
		2
	],
	"./record-editor/record-editor.module.ngfactory": [
		"G9oL",
		0,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "gFIY";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// /home/travis/build/inspirehep/record-editor/src/$$_gendir lazy
// module id = gFIY
// module chunks = 4